import { EListingOffersActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const removeOffers = actionGenerator<EListingOffersActionType.RemoveOffers>(
  EListingOffersActionType.RemoveOffers,
);
